import {type IAsset} from '../schema';

export const assetHasVersions = (asset?: IAsset): asset is IAsset => {
	return !!asset && asset.versionIds.length > 0;
};
